(function () {
    'use strict';

    angular.module("imApp").factory("infoScreenService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: method_no,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
